import { type IconId, isValidIconId } from '@stone-payments/jade'

export function resolveJadeIconId(iconId: string): IconId | undefined {
  const id = iconId.replace(/^jade_/, '').replace(/_/g, '-')

  return isValidIconId(id) ? id : undefined
}
